export default {
  'zh-CN': {
    templateIncorrect: '该按钮对应的模板配置有误，请联系系统管理员'
  },
  'en': {
    templateIncorrect: 'The template configuration corresponding to this button is incorrect, please contact the system administrator.'
  },
  'jp': {
    templateIncorrect: 'The template configuration corresponding to this button is incorrect, please contact the system administrator.'
  }
}
